import { useEffect, useState } from "react";
import { BrowserRouter, Routes } from "react-router-dom";
import { Navbar } from "./modules/Navbar/Navbar";
import { LoadingIndicator } from "./components/LoadingIndicator";
import { Api } from "./api";
import { AppRoutes, AuthAppRoutes } from "./routes";
import { useAuthContext } from "./modules/Auth";
import { useCacheContext, CacheKeys } from "./modules/Cache";
import "./App.css";
import { BasicLoginPage } from "./pages/BasicLoginPage";

const useApp = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated, isInitializing, isVerified, setIsVerified } =
    useAuthContext();
  const { saveToCache } = useCacheContext();

  const handleLogin = async (event: any) => {
    event.preventDefault();

    const { uname, password } = document.forms[0];

    const verified = await Api.login(uname.value, password.value);

    setIsVerified(verified);
  };

  useEffect(() => {
    const getEnvs = async () => {
      const data = await Api.getEnvs();

      saveToCache(CacheKeys.environments, data?.data?.countries);
      saveToCache(CacheKeys.internalEnvironments, data?.data?.internal);
      setIsLoading(false);
    };

    if (isVerified) getEnvs();
  }, [isVerified, saveToCache]);

  return {
    isAuthenticated,
    isLoading,
    isInitializing,
    isVerified,
    setIsVerified,
    handleLogin,
  } as const;
};

function App() {
  const {
    isAuthenticated,
    isLoading,
    isInitializing,
    isVerified,
    handleLogin,
  } = useApp();

  return (
    <BrowserRouter>
      {isVerified ? (
        <>
          {!isInitializing && <Navbar />}
          {isLoading ? (
            <LoadingIndicator isLoading={isLoading} size={80} />
          ) : (
            <Routes>{isAuthenticated ? AuthAppRoutes : AppRoutes}</Routes>
          )}
        </>
      ) : (
        <BasicLoginPage handleSubmit={handleLogin} />
      )}
    </BrowserRouter>
  );
}

export default App;
